/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


/* (function() {
  // Add custom code below this line
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
          e.preventDefault();
          const target = document.querySelector(this.getAttribute('href'));
  
          if (target) {
              console.log("Scrolling to:", target); // Debugging, zeigt das Ziel-Element an
  
              // Berechne die Position des Elements relativ zur Seite
              const targetRect = target.getBoundingClientRect();
              const scrollOffset = window.scrollY + targetRect.top;
  
              // Fenstergröße und Element-Höhe erfassen
              const viewportHeight = window.innerHeight;
              const elementHeight = targetRect.height;
  
              // **Sticky Header Höhe ermitteln**
              const stickyHeader = document.querySelector(".header-class"); // Falls dein Header fixiert ist, ersetze ".header-class"
              const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
  
              // **Finale Scroll-Position berechnen**
              const scrollToPosition = scrollOffset - (viewportHeight / 2) + (elementHeight / 2) - headerHeight;
  
              console.log("Final Scroll Position:", scrollToPosition); // Debugging
  
              // **Sanft scrollen**
              window.scrollTo({
                  top: scrollToPosition,
                  behavior: "smooth"
              });
          } else {
              console.log("Fehler: Ziel-Element nicht gefunden!");
          }
      });
  });


  document.addEventListener("DOMContentLoaded", function() {
      // Funktion zum Öffnen des Hauptmenüs "Cannabissamen"
      function openMainMenu() {
          var cannabissamenMenu = document.querySelector("#MobileNav--cannabissamen-0-sections--25318050398543__header");
          
          if (cannabissamenMenu && !cannabissamenMenu.classList.contains("is-expanded")) {
              // Suche den entsprechenden Trigger-Button für das Hauptmenü
              var mainTrigger = cannabissamenMenu.parentElement.querySelector("button.mobile-nav__trigger");
              if (mainTrigger) {
                  mainTrigger.click();
              }
          }
          
          return cannabissamenMenu && cannabissamenMenu.classList.contains("is-expanded");
      }
      
      // Funktion zum Öffnen des Untermenüs "Samenart"
      function openSamenartSubmenu() {
          // Korrekte Selektor für den "Samenart" Trigger-Button
          var samenartTrigger = document.querySelector("button.mobile-nav__trigger--level-2[aria-controls='MobileNav--cannabissamen-samenart-0-sections--25318050398543__header']");
          
          if (samenartTrigger) {
              var samenartMenu = document.querySelector("#MobileNav--cannabissamen-samenart-0-sections--25318050398543__header");
              
              if (samenartMenu && !samenartMenu.classList.contains("is-expanded")) {
                  samenartTrigger.click();
              }
              
              return samenartMenu && samenartMenu.classList.contains("is-expanded");
          }
          
          return false;
      }
      
      // Erst das Hauptmenü öffnen
      var mainMenuOpened = openMainMenu();
      
      if (!mainMenuOpened) {
          // Falls das Hauptmenü nicht sofort geöffnet wird, versuche es mehrfach
          var mainAttempts = 0;
          var mainInterval = setInterval(function() {
              var opened = openMainMenu();
              
              if (opened || mainAttempts > 5) {
                  clearInterval(mainInterval);
                  
                  if (opened) {
                      // Kurz warten und dann das Untermenü öffnen
                      setTimeout(function() {
                          openSubmenuWithRetry();
                      }, 100);
                  }
              }
              
              mainAttempts++;
          }, 200);
      } else {
          // Hauptmenü ist bereits offen, öffne das Untermenü
          setTimeout(function() {
              openSubmenuWithRetry();
          }, 100);
      }
      
      // Funktion zum wiederholten Versuchen das Untermenü zu öffnen
      function openSubmenuWithRetry() {
          var submenuOpened = openSamenartSubmenu();
          
          if (!submenuOpened) {
              var attempts = 0;
              var interval = setInterval(function() {
                  var opened = openSamenartSubmenu();
                  
                  if (opened || attempts > 10) {
                      clearInterval(interval);
                  }
                  
                  attempts++;
              }, 300);
          }
      }
  });

})(); 
*/

document.addEventListener('DOMContentLoaded', function() {
  // Funktion, die ausgeführt wird, wenn das mobile Menü geöffnet wird
  function openFirstMenuItem() {
    // Warten Sie einen kurzen Moment, bis das Menü vollständig geöffnet ist
    setTimeout(function() {
      // Finden Sie den ersten Navigationspunkt mit Untermenü
      const firstMenuItem = document.querySelector('.mobile-menu__item--has-items');
      
      if (firstMenuItem) {
        // Simulieren Sie einen Klick auf den Toggle-Button des ersten Menüpunkts
        const toggleButton = firstMenuItem.querySelector('.mobile-nav__trigger');
        if (toggleButton) {
          toggleButton.click();
        }
      }
    }, 100);
  }
  
  // Überwachen Sie das Öffnen des mobilen Menüs
  const menuToggle = document.querySelector('.js-mobile-nav-toggle, .mobile-nav-toggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', openFirstMenuItem);
  }
});